export const ROUTE_COMPANY_LISTS_DIRECTORY = "companyLists.directory";
export const ROUTE_COMPANY_LISTS_DETAIL = "companyLists.detail";
